// 참여수단 옵션
export const SigningMethodOptions = [
  { label: "이메일", value: "EMAIL" },
  { label: "휴대폰", value: "KAKAO" },
];

// 언어 옵션
export const LanguageOptions = [
  { label: "한국어", value: "ko" },
  { label: "영어", value: "en" },
  { label: "중국어", value: "zh-CN" },
  { label: "일본어", value: "ja" },
  { label: "베트남어", value: "vi" },
];

export const verificationOptions = [
  { title: "휴대폰", value: "mobileIdentification" },
  { title: "비밀번호", value: "password" },
  { title: "법인 공동 인증서", value: "dCert" },
];
